
/**
 * 		Search UI application views.
 *
 * 		@author Irina Patrikeeva <irina.i.patrikeeva@nasa.gov>
 *
 *     	Created in 2015
 *     	Modified on 06/30/2020
 */

/*jshint strict:false */
/*global Backbone, $, _, Handlebars, App, console, window */

// Override View.remove()'s default behavior
Backbone.View = Backbone.View.extend({
	remove: function() {
		// Empty the element and remove it from the DOM while preserving events
		$(this.el).empty().detach();
		return this;
	}
});


/**
 * Main content Backbone view where the body of the page is displayed
 */
var ContentView = Backbone.View.extend({
	// Initialize with the template-id
	initialize: function (options) {
		this.template = options.template;
	},

	// Get the template content and render it into a new div-element
	render: function () {
		var content = $(this.template).html();
		$(this.el).html(content);
		return this;
	}
});

/***
 * User view
 */
var UserView = Backbone.Marionette.ItemView.extend({
	model: UserModel,
	getPermissions: function( tryNumber ) {
		var url =  App.globalState.searchAPIBase + '/user';
		var data = {};

		this.existingRequest = $.ajax({
			url: url,
			data: data,
			dataType: 'json'
		})
		.done(function (response) {
			processUserPermissions(response);
		})
		.fail(function (jqXHR) {
			if (console && console.log) {
				console.log('Failed to fetch user permissions, url = ' + this.url);
			}
			if ( tryNumber <= 5 ) {
				retry( this.getPermissions( tryNumber + 1 ), tryNumber + 1, 5 );
			}
		});
	}
});

/**
 * Backbone ItemView of a single search filter
 */
var FilterView = Backbone.Marionette.ItemView.extend({
    tagName: 'li',
    className: 'filter-item',
    template: "#filter-template",
    onShow: function() {
        // setup href element of the filter
        var link = $( this.el ).find('a'),
            href;
        if ( link && link.length > 0 ) {
            href = getFilterRef( link );
            if ( href ) {
                link.removeClass( "disabled" );
                link.attr( 'href', href );
            } else {
                link.addClass( "disabled" );
            }
        }

    }
});

/**
 * Backbone CompositeView view of available search facets
 */
var FiltersView = Backbone.Marionette.CompositeView.extend({
    template: '#filters-field-template',
    childView: FilterView,
    model: FiltersModel,
    events: {
        'click a.filter-link': 'addFilter'
    },
    addFilter: function(e) {
        var value,
            field,
            label,
            el,
            filter,
            displayValue,
            type;
        e.preventDefault();

        // Set the global multi-facet to false
		if ( App.globalState.multifacets ) {
            App.globalState.multifacets = false;

            // Save date value into a variable
            var dateValue = getDateFilterValueFromURL();

            // Remove all type filters
			App.globalState.currentFilters.reset( null );

            // Add indexed field back if it exists
            if ( isGlobalDateFilterSet() && dateValue ) {

                addFilterToGlobal( "indexed", "Indexed", dateValue, DateFilter[ App.globalState.dateFilter ], "gt", "date" );
            }
        }

        el =  $(e.currentTarget).parents('.available-field');
        field = $(el).attr("name");
        label = $(el).attr("label");
        filter = $(e.currentTarget)[0];

        if ( filter ) {
            value = filter.name || '[ Empty ]';

            if ( ! filter.displayValue ) {
            	displayValue = $( filter ).attr("displayvalue");
            	if ( ! displayValue ) {
            		displayValue = value.capitalizeFirstLetter();
				}
			}

            type = filter.type || "string";

           	addFilter( field, label, value, displayValue, "eq", type );
        }
    }
});

/**
 * Backbone ItemView of currently selected search facets
 */
var CurrentFilterView = Backbone.Marionette.ItemView.extend({
    template: '#current-filter-template',
    model: FilterModel,
    events: {
        'click a.remove-filter' : 'removeFilter'
    },
    removeFilter: function(e) {
        var idArray,
            value,
            field,
            filter;
        e.preventDefault();
        idArray = e.currentTarget.id;
        value = idArray.split('-link')[ 0 ];
        field = $( e.currentTarget ).parents( '.current-field' )[ 0 ];
        filter = $( field ).find('span.active-filter')[ 0 ];
        removeFilter( $( filter ).attr( 'name' ), value, true );
    }
});

/**
 * Backbone ItemView for an empty current filters
 */
var EmptyFiltersView = Backbone.Marionette.ItemView.extend({
    template: '#message-template'
});

/**
 * Backbone collection for Search API records
 */
var RecordsCollection = Backbone.Collection.extend({
    model: ValueModel,
    existingRequest: null,

    /**
     * Fetch search records from the server
     * @param userQuery {string} user input in the search box
     * @param start {number} index of the first record of results
     * @param size {number} number of results to show on the page
	 * @param callback {Function} - function to call on success
     */
    getRecords: function ( userQuery, start, size, callback ) {
        var page = Math.floor( start / size ) + 1,
            url = App.globalState.searchAPIBase,
            query = modifyQuery(userQuery),
			fragment,
            data;

        if ( ! App.globalState.gettingRecords ) {
            App.globalState.gettingRecords = true;
            App.globalState.currentPage = page;

			// Construct the Ajax data object with API parameters
            data = getQueryDataObject( query );

            if ( data ) {

                // Set multi-facet flag to true if type is composed of several types
                if (  data.type && data.type.split(",").length > 1 ) {
                    // Set global multi-facet flag to true
                    App.globalState.multifacets = true;
                }

                // Check the current page
				fragment = Backbone.history.getFragment();
                if ( fragment && fragment.startsWith("search") ) {
                    // Set multi-facet flag to true if there is no type set
                    if ( ! data.type ) {
                        App.globalState.multifacets = true;
                    }
				}
			}

			// Check fuzzy / exact match search toggle
			// Fuzzy search can be enabled or disabled. When fuzzy is enabled, it can be turned ON (set) or OFF (not set)
            if ( isFuzzySet() && ! isFuzzyDisabled()) {
            	url += '/fuzzy';
			}
			// Check synonyms switch
			if ( isSynonymsSet() && ! isSynonymsDisabled() ) {
            	url += '/synonyms';
			}

            $.ajax({
                url: url,
                data: data,
                dataType: 'json'
            })
			.done( function ( response ) {
				App.globalState.gettingRecords = false;
				callback( response );
			})
			.fail( function ( jqXHR ) {
				App.globalState.gettingRecords = false;
				App.globalState.success = false;
				// clear previous search results and pagination
				if ( typeof App.globalState.layout.resultsRegion !== 'undefined' && App.globalState.layout.resultsRegion !== null ) {
					App.globalState.layout.resultsRegion.empty();

				}
				if ( typeof App.globalState.layout.summaryRegion !== 'undefined' && App.globalState.layout.summaryRegion !== null ) {
					App.globalState.layout.summaryRegion.empty();
				}
				// Display failure message
				if ( jqXHR.statusText && jqXHR.statusText.toLowerCase() !== "abort" ) {
					$('#sub-menu').hide();
					processErrorResponse( url, data, jqXHR, '#search-results' );
				}
				setFooter();
			});
		}

    }
});

/*** Backbone collection that represents a single ES record ***/
/*global KeyValueModel, displayRecord */
var SingleRecordCollection = Backbone.Collection.extend({
    model: KeyValueModel
});

/***
 * Backbone LayoutView for search results
 */
var SearchResultsLayoutView = Backbone.Marionette.LayoutView.extend({
    template: '#search-results-layout',
    regions: {
        summaryRegion: "#search-summary",
        searchToolsRegion: "#search-tools-region",
        resultsRegion: "#search-results-list",
		fodWikiRegion: '#fod-results-list',
        paginationRegion: "#pagination"
    },
    events : {
        'click #open-filters': 'toggleFilterDrawer',
        'click .facet-toggle': 'toggleFilterDrawer'
    },
    toggleFilterDrawer: function() {
        SlideMenu.toggle();
    }
});

/**
 * Backbone LayoutView for available filter
 */
var FiltersLayoutView = Backbone.Marionette.LayoutView.extend({
    template: '#filters-layout'
});

/**
 * Backbone LayoutView for current filters
 */
var CurrentFiltersLayoutView = Backbone.Marionette.LayoutView.extend({
    template: '#current-filters-layout'
});

/**
 * Backbone ItemView for a single search snippet
 */
var RecordView = Backbone.Marionette.ItemView.extend({
    tagName: 'li',
    className: 'eva record',
    template: '#data-driven-search-template',
    events: {
        'click a.title' : 'showSingleRecord'
    },

    showSingleRecord: function( e ) {
        e.preventDefault();
        App.globalState.query = $( 'input[name="basic-search"]' ).val();
        showSingleRecordView( $( e.currentTarget ) );
        return false;
    }
});

/**
 * Backbone CollectionView for search snippets
 */
var RecordsListView = Backbone.Marionette.CollectionView.extend({
    childView: RecordView
});

/**
 * Search results summary Backbone view
 */
var SummaryView = Backbone.Marionette.ItemView.extend({
    template: '#summary-template',
    ui: {
        filter: '#date-filter'
    },
    events: {
        'change @ui.filter' : 'filterByDate'
    },
    filterByDate: function(e) {
        var value,
            parentId;
        e.preventDefault();
        value = $(e.currentTarget).val();
        if ( value ) {
            parentId = '#date-filter';
            filterSearchResultsByDate( parentId, value );
        }
    }
});

/**
 * Error Backbone view
 */
var ErrorView = Backbone.Marionette.ItemView.extend({
	template: '#error-message-template'
});

/**
 * Graph chart parent template
 */
var ChartView = Backbone.Marionette.ItemView.extend({
	template: '#chart-template'
});

/*global nv, d3 */
/**
 * Graph chart child template
 */
var ChartsView = Backbone.Marionette.CollectionView.extend({
	childView: ChartView,

	onShow: function() {
		var c = this.collection,
				i,
				model,
				el;
		for (i = 0; i < this.collection.models.length; i++) {
			model = this.collection.models[i];
			el = '#' + model.get("id") + ' svg';
			this.discreteBarChart(model.get("data"), el, model.get("title"), true);
		}
	},

	discreteBarChart: function(data, el, title, discreteValues) {

		var nBuckets = data.buckets.length,
				dataObjString = '[{ "key": "' + title + '", "values": [',
				i,
				dataObj;

		if (nBuckets > 0) {
			for (i = 0; i < nBuckets - 1; i++) {
				dataObjString += '{ "label": "' + data.buckets[i].key + '",' + '"value":' + data.buckets[i].doc_count + '},';
			}

			dataObjString += '{ "label": "' + data.buckets[i].key.toString() + '",' + '"value":' + data.buckets[i].doc_count + '}]}]';
			dataObj = JSON.parse(dataObjString);

			nv.addGraph(function() {
				var duration = 300,
					chart = nv.models.discreteBarChart()
							.x(function(d) { return d.label; })
							.y(function(d) { return d.value; })
							.staggerLabels(true)
							.showValues(true)
							.duration(duration)
							.color(['#d3b7bc', '#72ab8f']);

				chart.tooltip.enabled(false);
				if (discreteValues) {
					chart.yAxis.tickFormat(d3.format('d'));
					chart.valueFormat(d3.format('d'));
				}

				d3.select(el).datum(dataObj)
						.call(chart);

				nv.utils.windowResize(chart.update);

				return chart;
			} ,function() {
				d3.selectAll('.discreteBar').on('click', function(event) {
					// TODO
					//var chartId = $(this).parents('.panel-body')[0].id;

				});
			});
		}
	}
});

/*global ChartCollection, ChartModel */
/**
 * Charts layout view that displays a collection of charts
 */
var ChartsLayoutView = Backbone.Marionette.LayoutView.extend({
	template: '#charts-layout',
	regions: {
		chartsRegion: "#charts"
	},
	initialize: function(data) {
		var i;
		this.data = {};
		this.data.charts = [];
		this.data.titles = [];
		this.data.ids = [];

		for (i = 0; i < data.charts.length; i++) {
			this.data.charts.push(data.charts[i]);
			this.data.titles.push(data.titles[i]);
			this.data.ids.push(data.ids[i]);
		}
	},
	onBeforeShow: function() {
		var chartCollection = new ChartCollection(),
				i,
				data,
				title,
				id,
				chart;
		for (i = 0; i < this.data.charts.length; i++) {
			data = this.data.charts[i];
			title = this.data.titles[i];
			id = this.data.ids[i];
			if (data.buckets.length > 0) {
				chart = new ChartModel();
				chart.set("title",title);
				chart.set("id", id);
				chart.set("data", data);
				chartCollection.add(chart);
			}
		}
		this.showChildView('chartsRegion', new ChartsView({ collection: chartCollection }));
	},
	events: {
		'click a.title-link' : 'clickOnTitle'
	},
	clickOnTitle: function(e) {
		var url,
				title,
				type;
		e.preventDefault();
		url = Backbone.history.getFragment();
		if (url.indexOf('type') < 0) {
			title = e.currentTarget.text;
			type = title.split('(')[1];
			type = type.replace(')', '');
			updateEndURL('/' + type, '', true);
		}

	}
});

// TODO: check if no longer used

/** EVA Dashboard Views ***/

/*global EventCollection */
/**
 * Dashboard for a single event
 */
var EventDashboardLayoutView = Backbone.Marionette.LayoutView.extend({
	template: '#event-dashboard-layout',
	collection: EventCollection,
	regions: {
		resultsRegion: '#results-region',
		eventRegion: '#event-region'
	}
});

/**
 * Event dashboard information template
 */
var EventInfoView = Backbone.Marionette.ItemView.extend({
	template: '#event-info-template',
	collection: EventCollection
});

/**
 * List view for all event documents (open and closed paperwork)
 */
var EventDocumentsListLayout = Backbone.Marionette.LayoutView.extend({
	template: '#event-documents-list-layout',
	collection: EventCollection,
	regions: {
		resultsRegion: '#results-region'
	},

	events: {
		'click a#back-to-event' : 'backToEvent'
	},

	backToEvent: function(e) {
		var url,
				to;
		e.preventDefault();
		url = Backbone.history.getFragment().split('/');
		to = 'hst/' + url[1] + '/' + url[2];
		updateURL(to, '', true, null);
	}
});

/**
 * Layout view for open and closed event documents
 */
var DocumentsResultsLayoutView = Backbone.Marionette.LayoutView.extend({
	template: '#documents-results-layout',

	regions: {
		summaryRegionOpen: "#search-summary-open",
		resultsRegionOpen: "#documents-results-list-open",
		summaryRegionClosed: "#search-summary-closed",
		resultsRegionClosed: "#documents-results-list-closed"
	}
});

/**
 * Event dashboard documents summary view
 */
var DocumentsSummaryView = Backbone.Marionette.ItemView.extend({
	template: '#documents-summary-template'
});

/**
 * Document charts layout view
 */
var DocumentsChartsLayoutView = Backbone.Marionette.LayoutView.extend({
	template: '#documents-layout',
	regions: {
		drRegion: '#dr-region',
		tpsRegion: '#tps-region',
		fabRegion: '#fab-region',
		odRegion: '#od-region',
		odtRegion: '#odt-region',
		wvrRegion: '#waiver-region',
		ecRegion: '#ec-region',
		fiarRegion: '#fiar-region',
		ytnRegion: '#ytn-region'
	}
});

/**
 * Event bill document collection
 */
/*global processDocumentsResponse, docCookies, processEventDocuments */
var EventDocumentCollection = Backbone.Collection.extend({

	getDocuments: function(eventId, type) {
		var status = "open",
				baseUrl = App.globalState.searchAPIBase + '/hst/documents/' + eventId + '/',
				url = baseUrl + type + '/' + status,
				open,
				closed;

		// get open documents
		$.get(url)
				.done(function(response){
					open = response;
					status = "closed";
					url = baseUrl + type + '/' + status;
					// get closed documents
					$.get(url)
							.done(function(response){
								closed = response;
								processDocumentsResponse(open, closed, type);
							})
							.fail(function(jqXHR){
								console.log('Failed to fetch search results for an event bill documents, eventId: ' + eventId + ', type: ' + type + ', status: ' + status);
								// Display failure message
								processErrorResponse(url, null, jqXHR, '#results-region');
							});

				})
				.fail(function(jqXHR){
					console.log('Failed to fetch search results for an event bill documents, eventId: ' + eventId + ', type: ' + type + ', status: ' + status);
					// Display failure message to the user
					processErrorResponse(url, null, jqXHR, '#results-region');
				});
	},

	getDocumentCounts: function (eventId) {
		var url = App.globalState.searchAPIBase + '/hst/documents/' + eventId;

		$.get(url)
				.done(function(response){
					docCookies.setItem('lastEventSeen', eventId, Infinity, '/', window.location.hostname, true);
					processEventDocuments(response);
				})
				.fail(function(jqXHR){
					console.log('Failed to fetch search results for an event documents, eventId: ' + eventId);
					// Display failure message to the user
					processErrorResponse(url, null, jqXHR, '#results-region');
				});
	}
});